import React from 'react';

import { ReactComponent as SoilMoistureIcon } from './soilMoistureIcon.svg';

function FarmbotSoilMoistureIcon() {
  return <SoilMoistureIcon width={18} />;
}

export default FarmbotSoilMoistureIcon;
